import { render, staticRenderFns } from "./inputfile.vue?vue&type=template&id=644eefa3"
import script from "./inputfile.js?vue&type=script&lang=js&external"
export * from "./inputfile.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports